var map = {
	"./#8794a5.svg": 64439,
	"./Admin.svg": 27992,
	"./BuildingTab.svg": 89408,
	"./BuildingTab2.svg": 13749,
	"./Configurer.svg": 13924,
	"./ConfiguringTab.svg": 25877,
	"./Created.svg": 62073,
	"./Deloitte.svg": 92635,
	"./Filtering.svg": 21050,
	"./Labeling.svg": 17155,
	"./Overview.svg": 93809,
	"./Succeeded.svg": 28905,
	"./SuperConfigurer.svg": 89467,
	"./SuperUser.svg": 6635,
	"./Unavailable.svg": 26478,
	"./Unknown.svg": 36370,
	"./User.svg": 63893,
	"./a-add.svg": 30967,
	"./a-edit.svg": 84536,
	"./a-star.svg": 8899,
	"./account-edit.svg": 74013,
	"./addlistitem.svg": 8529,
	"./addmorefiles.svg": 94245,
	"./adduser.svg": 71600,
	"./alarm-off.svg": 84129,
	"./alarm.svg": 50732,
	"./alltenantsadminscreen.svg": 7212,
	"./allusersadminscreen.svg": 46495,
	"./analysisservices.svg": 52301,
	"./app.svg": 12800,
	"./archive-drawer.svg": 25034,
	"./azure-synapse.svg": 44781,
	"./azureservicesadminicon.svg": 90936,
	"./azuresettingstenant.svg": 95790,
	"./b-preview.svg": 49025,
	"./badge-13.svg": 87335,
	"./badge-15.svg": 11241,
	"./bell.svg": 80204,
	"./bin.svg": 74854,
	"./blob-shape.svg": 11892,
	"./blueprint.svg": 44139,
	"./building.svg": 85953,
	"./businesskey.svg": 51390,
	"./buzz.svg": 31967,
	"./c-check.svg": 84358,
	"./c-check_animated.svg": 69200,
	"./c-question.svg": 94339,
	"./c.svg": 99256,
	"./calendar-date.svg": 64126,
	"./camera-flash.svg": 8174,
	"./check-list.svg": 32943,
	"./checkfileuploaded.svg": 14397,
	"./circle-08.svg": 18018,
	"./cloud-upload-96.svg": 18596,
	"./cogwheel.svg": 36276,
	"./companies.svg": 2573,
	"./config.svg": 44358,
	"./content-360deg.svg": 97474,
	"./css.svg": 54238,
	"./csv.svg": 60672,
	"./cursor-menu.svg": 16629,
	"./dashboardsolution.svg": 36401,
	"./dashboardsoptions.svg": 90028,
	"./dashboardsoverview.svg": 39901,
	"./dashboardstatus.svg": 46534,
	"./data-table.svg": 26861,
	"./database-outline.svg": 8710,
	"./databricks.svg": 88212,
	"./datafactory.svg": 90183,
	"./datamodeltax.svg": 46593,
	"./datetimeicon.svg": 24048,
	"./de.svg": 59643,
	"./deletefileoverview.svg": 24058,
	"./deletelistitem1.svg": 7729,
	"./deletelistitem2.svg": 400,
	"./diamond.svg": 67825,
	"./directions.svg": 36429,
	"./discardalluploadfiles.svg": 90329,
	"./dna-27.svg": 17444,
	"./document-2.svg": 15540,
	"./document-copy.svg": 98897,
	"./dots-to-close.svg": 46157,
	"./downloadfileoverview.svg": 13029,
	"./dropdown-down.svg": 8746,
	"./dropdown-down2.svg": 34153,
	"./du.svg": 9375,
	"./edit.svg": 59945,
	"./en-gcm.svg": 2973,
	"./en.svg": 71048,
	"./exchange.svg": 82267,
	"./exe.svg": 73955,
	"./expandactivity.svg": 13679,
	"./eye.svg": 14171,
	"./face-recognition.svg": 67744,
	"./failed.svg": 53517,
	"./fav-list.svg": 3952,
	"./file-unknown.svg": 8457,
	"./file.svg": 29333,
	"./filesOverviewTable.svg": 12840,
	"./fileuploaddelete.svg": 30944,
	"./fileuploadfailed.svg": 10289,
	"./fileuploadpause.svg": 29268,
	"./filter-organization.svg": 96941,
	"./filter-remove.svg": 59408,
	"./filter.svg": 41013,
	"./floes.svg": 49272,
	"./focus.svg": 25226,
	"./folder-16.svg": 58555,
	"./folder-cloud.svg": 2234,
	"./fr.svg": 97699,
	"./fullscreen-double-74.svg": 91434,
	"./funnel.svg": 4719,
	"./gif.svg": 36621,
	"./git-commit.svg": 28151,
	"./grid-interface.svg": 81509,
	"./hammer.svg": 38448,
	"./hdmi.svg": 74320,
	"./homelink.svg": 14818,
	"./html.svg": 43563,
	"./ic_add_24px.svg": 89665,
	"./ic_border_color_18px.svg": 12095,
	"./ic_close_24px.svg": 39881,
	"./ic_group_24px.svg": 76706,
	"./ic_people_24px.svg": 69171,
	"./ic_person_24px.svg": 79712,
	"./ic_person_add_24px.svg": 94524,
	"./ic_playlist_add_check_24px.svg": 46853,
	"./ic_save_24px.svg": 62018,
	"./initiatebuilding.svg": 3442,
	"./initiatebuilding2.svg": 71680,
	"./invoices.svg": 62807,
	"./journey-04.svg": 84239,
	"./jpg.svg": 68219,
	"./json.svg": 80178,
	"./layers-3.svg": 67652,
	"./listdownicon.svg": 88253,
	"./listupicon.svg": 9626,
	"./lockedup.svg": 35392,
	"./machine-learning.svg": 39640,
	"./magnifier.svg": 9500,
	"./mappingstatus.svg": 32555,
	"./menu/code.svg": 15661,
	"./menu/edit-curves.svg": 93895,
	"./menu/p-chart.svg": 5998,
	"./menu/setup-tools.svg": 69736,
	"./menu/spaceship.svg": 75390,
	"./menu/wireframe.svg": 29229,
	"./menudots.svg": 33017,
	"./monitorinfo.svg": 42881,
	"./multiple-11.svg": 27559,
	"./nav-right.svg": 80892,
	"./networking.svg": 39601,
	"./new-tab.svg": 9395,
	"./new/add_user.svg": 93841,
	"./new/analytics.svg": 78840,
	"./new/approve.svg": 58762,
	"./new/arrow.svg": 74316,
	"./new/box.svg": 41540,
	"./new/checkbox.svg": 18250,
	"./new/collapse.svg": 3659,
	"./new/dashboarding.svg": 97451,
	"./new/database.svg": 94569,
	"./new/delete.svg": 38102,
	"./new/download.svg": 60269,
	"./new/edit.svg": 1746,
	"./new/expand.svg": 40689,
	"./new/healthcheck.svg": 81150,
	"./new/help_center.svg": 69342,
	"./new/home.svg": 7231,
	"./new/information.svg": 45136,
	"./new/loader.svg": 54530,
	"./new/logout.svg": 74553,
	"./new/menu.svg": 59272,
	"./new/power_on.svg": 61228,
	"./new/profile.svg": 7346,
	"./new/quick_action.svg": 3823,
	"./new/restart.svg": 76890,
	"./new/services.svg": 1172,
	"./new/settings.svg": 26656,
	"./new/tenants.svg": 31966,
	"./new/toggle.svg": 38459,
	"./new/upload.svg": 10543,
	"./new/users.svg": 9778,
	"./new/where_you_left_off.svg": 82056,
	"./newnode.svg": 86940,
	"./newnode2.svg": 68819,
	"./nl.svg": 91824,
	"./no-alarm.svg": 45990,
	"./nodeselection.svg": 25262,
	"./noquery.svg": 9065,
	"./null.svg": 71067,
	"./office.svg": 20905,
	"./open-new-window.svg": 60180,
	"./opendashboard.svg": 9504,
	"./overwritenode.svg": 91227,
	"./overwritenode2.svg": 62897,
	"./paper.svg": 621,
	"./parametersfileoverview.svg": 46224,
	"./password.svg": 87219,
	"./pattern-recognition.svg": 48944,
	"./patternbg-01.svg": 74463,
	"./patternbg.svg": 38160,
	"./pin-2.svg": 28529,
	"./pipeline-warning.svg": 72447,
	"./pipelinestatus.svg": 36848,
	"./plug-2.svg": 6654,
	"./png.svg": 43392,
	"./position.svg": 58840,
	"./preview.svg": 46205,
	"./provisiontenant.svg": 26557,
	"./query-editor.svg": 83802,
	"./queryeditor.svg": 5450,
	"./question.svg": 40319,
	"./questionnaire.svg": 62083,
	"./ram-2.svg": 73143,
	"./rebuild-all.svg": 28482,
	"./rebuildall.svg": 53692,
	"./reloadall.svg": 23883,
	"./reprocessfileoverview.svg": 33185,
	"./road.svg": 23661,
	"./save.svg": 3754,
	"./search-content.svg": 56011,
	"./seeddatabase.svg": 38003,
	"./selection.svg": 47490,
	"./server-rack.svg": 77514,
	"./settings-gear.svg": 81526,
	"./setup-preferences.svg": 34590,
	"./share-26.svg": 11769,
	"./shirt.svg": 41115,
	"./single-01.svg": 6014,
	"./single-position.svg": 3747,
	"./slide-right.svg": 19415,
	"./small-right.svg": 34402,
	"./small-triangle-right.svg": 71427,
	"./sourceorigin.svg": 4438,
	"./sourcesoverview.svg": 6177,
	"./split-33.svg": 22460,
	"./sql.svg": 59762,
	"./sqldb4.svg": 19229,
	"./stack.svg": 87314,
	"./startbuildmodel.svg": 8504,
	"./startconfiguring.svg": 21341,
	"./startfileupload.svg": 78347,
	"./svg.svg": 79616,
	"./switcher.svg": 79819,
	"./t-warning.svg": 96868,
	"./table-move.svg": 47340,
	"./timelapse.svg": 8152,
	"./timeractivity.svg": 20196,
	"./timestart.svg": 17936,
	"./todo.svg": 78434,
	"./toggle-switch-off.svg": 94798,
	"./undefined.svg": 74371,
	"./unfold-dropdown.svg": 53549,
	"./unknownfileupload.svg": 51762,
	"./updatenode.svg": 73706,
	"./updatenode2.svg": 26242,
	"./uploadarrowetp.svg": 67386,
	"./userroles.svg": 58293,
	"./users-mm.svg": 84852,
	"./window-dev.svg": 80005,
	"./window-zoom-in.svg": 68448,
	"./wrench.svg": 73496,
	"./xls.svg": 70234,
	"./xml.svg": 95292,
	"./zip.svg": 11546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20866;